import {
    FormEngineRenderer,
    FormEngineRendererProps,
} from '@form-engine/core-application/components/engine';
import { useFormContext } from '@form-engine/core-application/hooks/use-form';
import classNames from '@form-engine/core-util/class-names';
import BsoFormEngineSessionRemote from './session-remote';

export default function BsoFormEngineRenderer({
    className,
    ...props
}: FormEngineRendererProps) {
    const { state: form } = useFormContext();
    return (
        <FormEngineRenderer
            {...props}
            className={classNames(className, form.bsoTheme)}
        >
            <BsoFormEngineSessionRemote />
        </FormEngineRenderer>
    );
}
